/* The historical filename is retained for existing theme includes. Lookup
 * submissions now go through Shopify checkout; this file never emits Klaviyo events. */
(function () {
  'use strict';
  const SKU = 'DigitalVtoPC';
  const PRICE = 199;
  const fields = [
    'pc_request_id', 'pc_lookup_method', 'pc_vin', 'pc_plate', 'pc_state',
    'pc_decoded_year', 'pc_decoded_make', 'pc_decoded_model', 'pc_decoded_ymm',
    'pc_decoded_paint_code', 'pc_decoded_paint_name', 'pc_frontend_validation_status',
    'pc_frontend_ymm_handle', 'processed_paint_code', 'pc_resolution_method',
    'pc_resolution_source', 'pc_resolution_product_handle', 'pc_resolution_variant_id'
  ];

  document.querySelectorAll('[data-paint-code-lookup][data-paid-checkout="true"]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-paint-code-lookup][data-paid-checkout="true"]').forEach(init);
  });

  function init(root) {
    if (root._paidCheckoutInitialized) return;
    root._paidCheckoutInitialized = true;
    let busy = false;
    const buttons = [...root.querySelectorAll('[data-paint-code-checkout]')];
    const enabled = root.dataset.checkoutEnabled === 'true';
    const routeRoot = window.Shopify?.routes?.root || '/';
    const url = (path) => routeRoot + path;
    const status = (text) => root.querySelectorAll('[data-checkout-status]').forEach((node) => { node.textContent = text; });
    function refresh() {
      buttons.forEach((button) => {
        button.disabled = busy || !enabled || !root._partifyPaintCodeRequest;
        button.textContent = busy ? 'Opening secure checkout…' : 'Get my paint code';
        button.setAttribute('aria-busy', String(busy));
      });
      if (!enabled) status('Online checkout is not available yet. Please check back soon.');
    }
    async function json(path, options = {}) {
      const response = await fetch(url(path), {
        credentials: 'same-origin', cache: 'no-store',
        ...options, headers: { Accept: 'application/json', ...options.headers },
        signal: AbortSignal.timeout(15000)
      });
      if (!response.ok) throw new Error('We couldn’t prepare checkout. Please try again.');
      return response.json();
    }
    function propertiesFor(pending) {
      const props = pending.props || {};
      const method = props.pc_lookup_method;
      if (!/^PCL-[A-Za-z0-9-]{8,120}$/.test(props.pc_request_id || '') || !['vin', 'plate'].includes(method)) {
        throw new Error('Please identify your vehicle again before checking out.');
      }
      if ((method === 'vin' && !/^[A-HJ-NPR-Z0-9]{17}$/.test(props.pc_vin || '')) ||
          (method === 'plate' && (!props.pc_plate || !props.pc_state))) {
        throw new Error('Please check your vehicle information and try again.');
      }
      const result = { Vehicle: String(props.pc_decoded_ymm || ''), _pc_schema: '1',
        _digital_access_key: Array.from(crypto.getRandomValues(new Uint8Array(32)), byte => byte.toString(16).padStart(2, '0')).join('') };
      if (props.pc_vin) result.VIN = props.pc_vin;
      if (method === 'plate') result['License plate'] = `${props.pc_plate} (${props.pc_state})`;
      for (const field of fields) {
        if (props[field] != null && props[field] !== '') {
          const value = String(props[field]);
          if (value.length > 255) throw new Error('Please identify your vehicle again before checking out.');
          result['_' + field] = value;
        }
      }
      return result;
    }
    async function checkout() {
      if (busy || !enabled) return;
      const pending = root._partifyPaintCodeRequest;
      if (!pending) return;
      const properties = propertiesFor(pending);
      busy = true;
      status('');
      refresh();
      try {
        const [product, cart] = await Promise.all([
          json(`products/${encodeURIComponent(root.dataset.checkoutProduct)}.js`), json('cart.js')
        ]);
        const variant = product.variants?.find((item) => item.sku === SKU);
        if (cart.currency !== 'USD') throw new Error('This lookup is currently available in USD. Please switch to the US store currency.');
        if (!variant?.available || variant.requires_shipping !== false || variant.price !== PRICE) {
          throw new Error('The $1.99 lookup is currently unavailable. Please try again later.');
        }
        if (root._partifyPaintCodeRequest !== pending) throw new Error('Your vehicle changed. Please confirm it before checking out.');
        // A failed response can still have added the item. Reuse that line on
        // retry/back navigation, without clearing or replacing physical items.
        const existing = cart.items?.find((item) => {
          if (String(item.variant_id) !== String(variant.id)) return false;
          const p = item.properties || {};
          if (p._pc_schema !== '1') return false;
          if (p._pc_request_id === properties._pc_request_id) return true;
          return p._pc_lookup_method === properties._pc_lookup_method && (
            properties._pc_vin ? p._pc_vin === properties._pc_vin :
            p._pc_plate === properties._pc_plate && p._pc_state === properties._pc_state
          );
        });
        if (existing) {
          if (existing.quantity !== 1 || !/^[a-f0-9]{64}$/.test(existing.properties?._digital_access_key || '')) {
            await json('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: existing.key, quantity: 1, properties: { ...existing.properties, _digital_access_key: /^[a-f0-9]{64}$/.test(existing.properties?._digital_access_key || '') ? existing.properties._digital_access_key : properties._digital_access_key } }) });
          }
        } else {
          await json('cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties }] })
          });
        }
        if (root._partifyPaintCodeRequest !== pending) throw new Error('Your vehicle changed. Please confirm it before checking out.');
        // No success flag, email, or research is emitted by the browser.
        pending.submitted = true;
        window.location.assign(url('checkout'));
      } catch (error) {
        busy = false;
        status(error.name === 'TimeoutError' ? 'Checkout took too long to respond. Please try again; we’ll check your cart first.' : error.message);
        refresh();
      }
    }
    root.addEventListener('partify:paint-code-ready', () => { if (enabled) status(''); refresh(); });
    buttons.forEach((button) => button.addEventListener('click', () => checkout().catch((error) => { status(error.message); })));
    window.addEventListener('pageshow', () => { busy = false; refresh(); });
    refresh();
  }
})();
